import React from 'react';
import ReactDOM from 'react-dom';
import './loading-overlay.scss';
import Spinner from '../spinner';

const LoadingOverlay: React.FC<any> = () => {
    if (document) {
        return ReactDOM.createPortal((
            <div className="loading-overlay">
                <Spinner />
            </div>
        ), document.body);
    }

    return null;
};

export default LoadingOverlay;
